import {css, cx as addStyles} from '@emotion/css';
import {theme} from '@remoov/remoov-components';
import React, {HTMLAttributes, ReactNode} from 'react';
import {DashboardCard, DashboardCardTitle, textBaseStyle} from './Common';

export type ListCardProps = {
  title: string;
  items: ReactNode[];
  emptyMessage?: string;
};

export const ListCard = ({title, items, emptyMessage}: ListCardProps) => (
  <DashboardCard>
    <DashboardCardTitle>{title}</DashboardCardTitle>
    {items.length === 0 ? (
      <EmptyMessage>{emptyMessage}</EmptyMessage>
    ) : (
      <List>
        {items.map((item, index) => (
          <Item key={index}>{item}</Item>
        ))}
      </List>
    )}
  </DashboardCard>
);
const List = (args: HTMLAttributes<HTMLOListElement>) => (
  <ol
    className={css({
      width: '100%',
      counterReset: 'list',
      marginLeft: '22px',
      '> li': {
        listStyle: 'none',
        position: 'relative',
      },
      '> li:before ': {
        counterIncrement: 'list',
        content: `counter(list, decimal) ') '`,
        position: 'absolute',
        left: '-1.4em',
      },
      'a ': {
        color: theme.colors.darkGray,
        fontSize: theme.font.sizes.small,
        fontFamily: theme.font.family,
        fontWeight: theme.font.normal,
      },
    })}
    {...args}
  />
);
const Item = (args: HTMLAttributes<HTMLLIElement>) => (
  <li
    className={addStyles(textBaseStyle, css({'& + li': {marginTop: theme.spacings.xxsmall}}))}
    {...args}
  />
);
const EmptyMessage = (args: HTMLAttributes<HTMLParagraphElement>) => (
  <p className={textBaseStyle} {...args} />
);
